import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";

export const LocationDetails = [
  {
    id: 1,
    icon: FaMapMarkerAlt,
    href: "",
    title: "SHOWROOM AND OFFICE (Sydney)",
    body: "Promotional Products Now\nUnit 9, 8 Avenue of the Americas\nNEWINGTON NSW 2127",
  },
  {
    id: 2,
    icon: FaMapMarkerAlt,
    href: "",
    title: "POSTAL ADDRESS",
    body: "Promotional Products Now \nPO Box 6373 \nSILVERWATER NSW 2128",
  },
  {
    id: 3,
    icon: FaPhoneAlt,
    href: "tel: 1300 664999",
    title: "PHONE",
    body: ["Ph: 1300 664999 (Australia)", "+61 2 8852 4900 (International)"],
  },
  {
    id: 4,
    icon: FaEnvelope,
    href: "mailto:sales@promotionalproductsnow.au",
    title: "EMAIL",
    body: "sales@promotionalproductsnow.au",
  },
];
